import ForbiddenError from "@/components/errors/forbidden";
import { createRoute } from "@tanstack/react-router";
import { errorLayoutRoute } from "../__root";
import { ROUTER_HELPERS } from "@/shared/constants/router";

export const forbiddenErrorRoute = createRoute({
  getParentRoute: () => errorLayoutRoute,
  path: ROUTER_HELPERS.error(403),
  component: ForbiddenError,
});
